import { jsx } from "react/jsx-runtime";
import FormatSizeIcon from "@mui/icons-material/FormatSize";
import { validateTidalLicense } from "../../base/index.js";
function FormatSize(props) {
  return /* @__PURE__ */ jsx(
    FormatSizeIcon,
    {
      "data-testid": "FormatSize",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "FormatSize",
      "data-tidal-icon-meta": "editing,attachment"
    }
  );
}
FormatSize.tidalIconMeta = {
  categories: "editing,attachment",
  name: "FormatSize"
};
validateTidalLicense();
export {
  FormatSize
};
//# sourceMappingURL=FormatSize.js.map
